// 디자인 시스템 기반 토큰 정의
export const designTokens = {
  // 영어 폰트 시스템
  typography: {
    english: {
      headline1: {
        fontSize: "36px",
        lineHeight: "130%",
        letterSpacing: "0%",
        fontWeight: "bold", // Bold
      },
      title1: {
        fontSize: "32px",
        lineHeight: "130%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      title2: {
        fontSize: "20px",
        lineHeight: "130%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      title3: {
        fontSize: "18px",
        lineHeight: "150%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
    },

    // 한글 폰트 시스템
    korean: {
      headline1: {
        fontSize: "28px",
        lineHeight: "130%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      title1: {
        fontSize: "20px",
        lineHeight: "150%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      body1: {
        fontSize: "18px",
        lineHeight: "150%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      body2: {
        fontSize: "16px",
        lineHeight: "150%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      body2_2: {
        fontSize: "16px",
        lineHeight: "170%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      body2_bold: {
        fontSize: "16px",
        lineHeight: "150%",
        letterSpacing: "0%",
        fontWeight: "bold", // Bold
      },
      body3: {
        fontSize: "14px",
        lineHeight: "150%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      body3_semibold: {
        fontSize: "14px",
        lineHeight: "150%",
        letterSpacing: "0%",
        fontWeight: "semibold", // Semibold
      },
      body4: {
        fontSize: "12px",
        lineHeight: "130%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
      body5: {
        fontSize: "10px",
        lineHeight: "130%",
        letterSpacing: "0%",
        fontWeight: "regular", // Regular
      },
    },

    // 폰트 가중치
    fontWeight: {
      regular: 400,
      semibold: 600,
      bold: 700,
    },
  },

  // 패딩 시스템
  padding: {
    "24x16": { top: "24px", right: "16px", bottom: "24px", left: "16px" },
    "32x16": { top: "32px", right: "16px", bottom: "32px", left: "16px" },
    "32x24": { top: "32px", right: "24px", bottom: "32px", left: "24px" },
    "40x40": { top: "40px", right: "40px", bottom: "40px", left: "40px" },
    "40x32": { top: "40px", right: "32px", bottom: "40px", left: "32px" },
  },

  // 아이콘 텍스트 타이틀 간격
  iconTextSpacing: {
    "20px": "20px",
    "10px": "10px",
  },

  // 태그 시스템
  tag: {
    "12x2": { padding: "12px 2px" },
    "10x4": { padding: "10px 4px" },
    "12x8": { padding: "12px 8px" },
  },

  // 아이콘 사이즈
  iconSize: {
    small: "16x16",
    medium: "24x24",
    large: "30x30",
  },

  // 컬러 시스템
  colors: {
    font: {
      primary: "#000000",
      secondary: "#33353D",
      tertiary: "#727272",
      quaternary: "#A5A5AE",
      quinary: "#D4D4D4",
      senary: "#F2F2F2",
      septenary:
        "linear-gradient(45deg, rgba(112, 122, 149, 1) 0%, rgba(29, 59, 98, 1) 50%, rgba(1, 8, 46, 1) 100%)",
      octonary: "#FFFFFF",
    },
    // 라인 컬러 (기본 색상)
    line: {
      box: "linear-gradient( -45deg, rgba(29, 59, 98, 0.03) 0%, rgba(29, 59, 98, 0.1) 30.889856815338135%, rgba(29, 59, 98, 0.15) 62.94351816177368%, rgba(29, 59, 98, 0.05) 100%)",
      section: "#ebeef1",
      button: "#e7ebf1",
      point:
        "linear-gradient( -45deg, rgba(112, 122, 149, 1) 0%, rgba(29, 59, 98, 1) 50%, rgba(1, 8, 46, 1) 100%)",
    },

    // 박스 컬러 (배경/상태 색상)
    box: {
      primary: "#f2f7ff",
      secondary:
        "linear-gradient( -45deg, rgba(112, 122, 149, 1) 0%, rgba(29, 59, 98, 1) 50%, rgba(1, 8, 46, 1) 100%)",
    },

    // 인덱스 컬러 (다양한 색상 팔레트)
    index: {
      blue: "#4b5eff", // 파란색
      teal: "#21c4c4", // 청록색
      orange: "#ffb84d", // 주황색
      pink: "#ff23bd", // 분홍색
      gray: "#64748b", // 회색
      green: "#3bb54a", // 녹색
      purple: "#aa00ff", // 보라색
    },

    // 버튼 컬러
    button: {
      primary: "#000000", // 검은색
      secondary: "#4b5eff", // 파란색
    },

    // 공정 부정 컬러 (상태 표시용)
    status: {
      positive: "#1570e1", // 파란색 (공정)
      negative: "#ea5028", // 빨간색 (부정)
    },

    icon: {
      primary:
        "linear-gradient( -45deg, rgba(29, 59, 98, 0.03) 0%, rgba(255, 255, 255, 0.1) 30.889856815338135%, rgba(29, 59, 98, 0.15) 62.94351816177368%, rgba(29, 59, 98, 0.05) 100%)",
    },

    // background
    background: {
      primary: "#f9f9f9",
    },
  },

  // 간격 시스템 (일반적인 spacing)
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "28px",
    "4xl": "32px",
    "5xl": "40px",
  },

  // 둥글기
  borderRadius: {
    sm: "4px",
    md: "8px",
    lg: "12px",
    xl: "16px",
    full: "50%",
  },

  // 그림자
  shadows: {
    sm: "0 1px 2px rgba(0, 0, 0, 0.05)",
    md: "0 4px 6px rgba(0, 0, 0, 0.1)",
    lg: "0 10px 15px rgba(0, 0, 0, 0.1)",
    xl: "0 20px 25px rgba(0, 0, 0, 0.1)",
  },

  // 전환 효과
  transitions: {
    fast: "0.15s ease",
    normal: "0.3s ease",
    slow: "0.5s ease",
  },
};

// 헬퍼 함수들
export const getTypography = (
  language: "english" | "korean",
  variant: string
) => {
  if (language === "english") {
    return designTokens.typography.english[
      variant as keyof typeof designTokens.typography.english
    ];
  } else {
    return designTokens.typography.korean[
      variant as keyof typeof designTokens.typography.korean
    ];
  }
};

export const getPadding = (size: keyof typeof designTokens.padding) => {
  const padding = designTokens.padding[size];
  return `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}`;
};

export const getIconSize = (size: keyof typeof designTokens.iconSize) => {
  const [width, height] = designTokens.iconSize[size].split("x");
  return { width: `${width}px`, height: `${height}px` };
};
